export default __webpack_public_path__ + "static/media/go-to-my-claims.4a53a9fa.svg";